import React from 'react';
import { NovovilleButton, Typography } from '@/components/novoville';
import { BorderedPanel, PageShell } from './PanelLayout';

const MessagePanel = ({ title, description, actionText, onAction }) => (
  <PageShell>
    <BorderedPanel>
      <div className="flex flex-col gap-2">
        <Typography variant="bold_24">{title}</Typography>
        <Typography variant="regular_16">{description}</Typography>
      </div>

      {actionText && onAction && (
        <NovovilleButton
          variant="primary"
          text={actionText}
          onClick={onAction}
        />
      )}
    </BorderedPanel>
  </PageShell>
);

export default MessagePanel;
